import { EntityTypeCode, useFetchCallType, useViewerEntity } from '@rahtab/auth/lib/token-based-auth';
import { useAppDispatch, useSelector } from 'rahtab-redux';
import { addLoads, parseLoadFromAssignPrimaries } from 'rahtab-redux/slices/loadsSlice';
import { ServerFullInfo } from './useLoadsList';

export const useLoad = ({ assignFinalCode }: Args) => {
  const { viewerSelectedEntity } = useViewerEntity();
  const { loads } = useSelector((state) => state.loads);
  const dispatch = useAppDispatch();
  const finalCode = [assignFinalCode];
  const [refetchAssignFinal, { loading }] = useFetchCallType<ServerFullInfo[]>('GetInventoryAssignFinallInfo', {
    skip: viewerSelectedEntity?.typeCode !== EntityTypeCode.Provider || !!loads[assignFinalCode],
    params: `AssignFinallCode=${JSON.stringify(finalCode)}`,
    onCompleted: (data) => dispatch(addLoads(data)),
  });
  const [refetchAssignPrimary, { loading: loadingAssignPrimary }] = useFetchCallType<ServerAssignPrimary[]>(
    'GetInventoryAssignPrimaryInfo',
    {
      skip: viewerSelectedEntity?.typeCode !== EntityTypeCode.Middleman || !!loads[assignFinalCode],
      params: `AssignPrimaryCode=${JSON.stringify(finalCode)}`,
      onCompleted: (data) => dispatch(parseLoadFromAssignPrimaries(data)),
    },
  );

  return {
    refetch: viewerSelectedEntity?.typeCode === EntityTypeCode.Middleman ? refetchAssignPrimary : refetchAssignFinal,
    loading: loading || loadingAssignPrimary || !loads[assignFinalCode],
    called: !!loads[assignFinalCode],
    data: loads[assignFinalCode],
  };
};

interface Args {
  assignFinalCode: string;
}

export interface ServerAssignPrimary {
  AssignPrimaryCode: string;
  APIdentification: string;
  LoadName: string;
  RegulationTag: string;
  TemplateName: string;
  SupplierName: string;
  Amount: string;
  MeasureCode: string;
  MeasureName: string;
  PricePerUnit: string;
  TotalPrice: string;
  StatusCode: string;
  Status: string;
  AssignDate: string;
  DeliveryDate: string;
  ReceiveDate: string;
  SaleAmount: string;
  RemainingValue: string;
  CorrectionAmount: string;
  ReturnAmount: string;
  SalePercent: string;
  RemainingPercent: string;
  CorrectionPercent: string;
  ReturnPercent: string;
  /** مقدار اعلام وصول شده */
  ReceivedAmount: string;
  /** مقدار تخصیص واقعی */
  OriginalAmount: string;
  /** قیمت تخصیص واقعی */
  OriginalPricePerUnit: string;
}
